/** TanStack Query cache keys, in one place. */
export const queryKeys = {
  publicConfig: ['config', 'public'] as const,
  me: ['me'] as const,
  invitePreview: (token: string) => ['invite-preview', token] as const,
  members: ['team', 'members'] as const,
  invites: ['team', 'invites'] as const,
  apiKeys: ['api-keys'] as const,
  workspaces: ['workspaces'] as const,
  domains: (workspaceId: string) => ['domains', workspaceId] as const,
  domain: (domainId: string) => ['domain', domainId] as const,
  mailboxes: (workspaceId: string) => ['mailboxes', workspaceId] as const,
  leads: (workspaceId: string, query: object) => ['leads', workspaceId, query] as const,
  leadFacets: (workspaceId: string) => ['lead-facets', workspaceId] as const,
  leadStats: (workspaceId: string) => ['lead-stats', workspaceId] as const,
  lead: (leadId: string) => ['lead', leadId] as const,
  leadLists: (workspaceId: string) => ['lead-lists', workspaceId] as const,
  leadImports: (workspaceId: string) => ['lead-imports', workspaceId] as const,
  leadImport: (importId: string) => ['lead-import', importId] as const,
  verificationJobs: (workspaceId: string) => ['verification-jobs', workspaceId] as const,
  verificationJob: (jobId: string) => ['verification-job', jobId] as const,
  verificationSettings: ['verification-settings'] as const,
  suppressions: (workspaceId: string, query: object) =>
    ['suppressions', workspaceId, query] as const,
  suppressionStats: (workspaceId: string) => ['suppression-stats', workspaceId] as const,
  suppressionSettings: (workspaceId: string) => ['suppression-settings', workspaceId] as const,
  unsubscribe: (token: string) => ['unsubscribe', token] as const,
};
